import styled, { css } from "styled-components";

const Container = styled.div<{ isCustomStyle?: boolean }>`
  margin-top: 40px;
  background: white;
  padding: 20px 15px;
  border-radius: 4px;
  font-family: "Inter", sans-serif!important;
  box-shadow: 0px 4px 30px 10px rgba(0, 0, 0, 0.1);
  color: black;

  ${({ isCustomStyle }) =>
    isCustomStyle &&
    css`
      color: var(--hero-text);
      background: transparent;
      padding: 0;
      margin-top: 0;
      box-shadow: none;

      a,
      p {
        
        color: var(--hero-text);
        line-height: 27px;
        font-family: "Inter", sans-serif;
        font-size: 18px;
        font-weight: 400;
      }
      a {
        text-decoration: underline;
      }
    `}
`;

const Instruction = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  font-size: 18px;
  font-family: "Inter", sans-serif !important;
  p, strong, em, a{
    font-family: "Inter", sans-serif !important;

  }
  ul {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    padding: 0 15px;
    margin: 0;
    font-family: "Inter", sans-serif;
    line-height: 1.5em;

    @media (max-width: 767px) {
      font-size: 14px;
    }
  }
`;

export const S = {
  Container,
  Instruction,
};
